import { createSimpleFunctional } from '@/util'

export const VCardContent = createSimpleFunctional('v-card-content')
